import { createFileRoute } from "@tanstack/react-router";

import { BaseEditCreateModal } from "@/components/_Modals/BaseEditCreateModal";
import { TruckContent } from "@/features/dashboard/caminhoes/components/TruckContent";

export const Route = createFileRoute("/_private/dashboard/_trucks/caminhoes/carregamentos/editar/$id/modal")({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <BaseEditCreateModal title="Editar Carregamento" from="/dashboard/caminhoes/carregamentos/editar/$id">
      <TruckContent />
    </BaseEditCreateModal>
  );
}
